import { Component, OnInit, AfterViewInit, OnDestroy, Inject, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AdminUsersComponent } from '../admin-users/admin-users.component';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { LoginService } from 'src/app/managers/login.service';
import { User } from 'src/app/models/user';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { CoreResponseMessage, CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { ClientConfigService } from 'src/app/common/services/client-config.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('usernameField', { static: true }) userNameElement: ElementRef;
  userToUpdate: User;
  isUserActive: string;  
  isLoggedin: string;  

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _functionsService: FunctionsService, 
              private _snackBar: MatSnackBar, public dialogRef: MatDialogRef<AdminUsersComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    super(route, loginManager, clientConfig, dialog);
  }

  ngOnInit() {
    super.ngOnInit();
    this.parentComponent = this.data.parentComponent;
    this.dataSource = this.data.dataSource;
    this.userToUpdate = this._functionsService.deepCopy<User>(this.dataSource);
    this.isUserActive = String(this.userToUpdate.Active);      
    this.isLoggedin = String(this.userToUpdate.IsLoggedIn) === 'true' ? 'Yes' : 'No';    
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.userNameElement.nativeElement.focus();
    }, 0)
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  async update() {
    this.userToUpdate.Active = this.isUserActive === 'true' ? true : false;
    this.userToUpdate.Role = null;
    this.userToUpdate.IsLoggedIn = null;
    this.userToUpdate.LastActivityTime = null;
    this.userToUpdate.CreatedDate = null;
    this.userToUpdate.ApplicationId = 0;
    this.userToUpdate.ApplicationName = null;
    this.userToUpdate.ApplicationKey = null;
    this.userToUpdate.IsAdmin = null;

    this._snackBar.open('Updating...');
    let responseMsg: CoreResponseMessage = await this.loginManager.updateUserAsync(this.userToUpdate);
    this._snackBar.dismiss();

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this._snackBar.open('The user has been updated successfully.', 'OK', { duration: this._successMsgDuration });      
    }
    else {
      this.handleCoreResponseMessageError(responseMsg);
      let alertStr = 'Failed to update the user: ' + responseMsg.Message;
      this.openAlertDialog('Edit User', alertStr, '400px', '200px');
    }

    this.dialogRef.close(responseMsg);
  }

  cancel() {  
    this.dialogRef.close(null);
  }
}
